export const APPLICANT_TYPE = {
    PRIMARY: 'principal',
    COAPPLICANT: 'coapplicant',
};
